import {
  FETCH_PENDING_REQUEST_COUNT_REQUEST,
  FETCH_PENDING_REQUEST_COUNT_SUCCESS,
  FETCH_PENDING_REQUEST_COUNT_FAILURE,
} from '../../../../Constants/actionTypes';
import { fetchPendingRequestCount } from '../../../../Constants/apiService';

export const fetchPendingRequestCountRequest = () => ({
  type: FETCH_PENDING_REQUEST_COUNT_REQUEST,
});

export const fetchPendingRequestCountSuccess = data => ({
  type: FETCH_PENDING_REQUEST_COUNT_SUCCESS,
  payload: data,
});

export const fetchPendingRequestCountFailure = error => ({
  type: FETCH_PENDING_REQUEST_COUNT_FAILURE,
  payload: error,
});

export const fetchPendingRequestCountAct = () => async (dispatch, getState) => {
  dispatch(fetchPendingRequestCountRequest());

  try {
    const accessToken = getState()?.auth?.accessToken;
    const response = await fetchPendingRequestCount(accessToken);
    dispatch(fetchPendingRequestCountSuccess(response));
    return response;
  } catch (error) {
    const errorMessage =
      error?.message || 'Failed to fetch pending request count';
    dispatch(fetchPendingRequestCountFailure(errorMessage));
    return null;
  }
};
